import sdl from '@jds/react-generated-sdl/JDSMobileBottomSheetInternal';
import type { JDSMobileBottomSheetInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMobileBottomSheetInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'overlay',
    controlType = 'normal',
    isCustom = false,
    close = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    ariaLabel = 'Bottom Sheet Content',
    cancelButtonAriaLabel = 'Close Modal',
    backButtonAriaLabel = 'Tap to go back',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      controlType,
      isCustom,
      close,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ariaLabel,
      cancelButtonAriaLabel,
      backButtonAriaLabel,
      ...rest
    },
    'JDSMobileBottomSheetInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MobileBottomSheetInternal = withLogic(
  Component
) as React.FC<JDSMobileBottomSheetInternalProps> & { slotName?: string };

MobileBottomSheetInternal.displayName = 'MobileBottomSheetInternal';
MobileBottomSheetInternal.slotName = 'jds_mobile_bottom_sheet_internal';

export { MobileBottomSheetInternal, type JDSMobileBottomSheetInternalProps };
